/* eslint-disable no-lonely-if */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  tableCellClasses,
  Paper,
  Grid,
  Stack,
  styled,
  MenuItem,
  Chip,
  Autocomplete,
  FormControlLabel,
  Checkbox,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Accordion,
  Collapse,
  Dialog,
  DialogTitle,
  DialogContent,
} from '@mui/material';
import moment from 'moment';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { Person, Email, Phone, LocationOn } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import PortraitIcon from '@mui/icons-material/Portrait';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { useNavigate } from 'react-router-dom';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Container } from 'reactstrap';
import nAxios from 'axios'
import PreviewIcon from '@mui/icons-material/Preview';
import axios from '../../../utils/axios';
import UIContext from '../../../context/UIContext';
import CourierOrderCreation from '../Booking/CourierOrderCreation';

const StyledTableCell = styled(TableCell)({
  color: 'white',
  fontWeight: '600',
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#257180',
  },
  whiteSpace: 'nowrap',
});

const ManagePickUp = () => {
  const navigate = useNavigate();
  const [getDataForView, setGetDataForView] = useState([]);
  // snackbar context
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [expanded, setExpanded] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [ledgerPhoneFilterData, setLedgerPhoneFilterData] = useState([]);
  const [countryFilterData, setCountryFilterData] = useState([]);
  const [pinCodeFilterData, setPinCodeFilterData] = useState([]);
  const [filterInputs, setFilterInputs] = useState({
    country: '',
    pinCode: [],
    pickUpDate: '',
  });

  useEffect(() => {
    GetAllHelpData();
  }, []);

  const GetAllHelpData = async () => {
    try {
      showLoading();
      const [country, salesExecutiveResponse] = await Promise.all([
        nAxios.get(' https://restcountries.com/v3.1/all'),
        axios.get('/Approval/LoginApprovalRoute/GetAllSalesExecutive'),
      ]);
      const countryNames=country.data.map(country=>country.name.common)
      const sortedCountryName=countryNames.sort()
      setCountryFilterData(sortedCountryName);
    } catch (e) {
      console.log(e.message);
      openSnackBar('Something Went Wrong', 'error');
    }
    hideLoading();
  };

  const handleFilterInputs = (e) => {
    setFilterInputs({
      ...filterInputs,
      [e.target.name]: e.target.value,
    });
  };

  async function getAllData() {
    try {
      showLoading();
      if (filterInputs.type !== 'All') {
        const response = await axios.get(
          `/Transactions/${filterInputs.type}/GetAllOrder/${filterInputs.ledger.CUSTOMERID || 0}/${moment(
            filterInputs.fromDate
          ).format('YYYYMMDD')}/${moment(filterInputs.toDate).format('YYYYMMDD')}/${
            filterInputs.salesExecutive.salesPersonId || 0
          }/${filterInputs.approvalStatus}/${filterInputs.customizedItems}/${filterInputs.droppedOrder}`
        );
        if (tableData.length === 0 && response.data.length !== 0) setExpanded(false);
        setTableData(response.data);
      } else {
        const [response1, response2] = await Promise.all([
          axios.get(
            `/Transactions/Courier/GetAllOrder/${filterInputs.ledger.CUSTOMERID || 0}/${moment(
              filterInputs.fromDate
            ).format('YYYYMMDD')}/${moment(filterInputs.toDate).format('YYYYMMDD')}/${
              filterInputs.salesExecutive.salesPersonId || 0
            }/${filterInputs.approvalStatus}/${filterInputs.customizedItems}/${filterInputs.droppedOrder}`
          ),
          axios.get(
            `/Transactions/Cargo/GetAllOrder/${filterInputs.ledger.CUSTOMERID || 0}/${moment(
              filterInputs.fromDate
            ).format('YYYYMMDD')}/${moment(filterInputs.toDate).format('YYYYMMDD')}/${
              filterInputs.salesExecutive.salesPersonId || 0
            }/${filterInputs.approvalStatus}/${filterInputs.customizedItems}/${filterInputs.droppedOrder}`
          ),
        ]);

        const data = [...response1.data, ...response2.data].sort((a, b) => a.orderDate.localeCompare(b.orderDate));
        if (tableData.length === 0 && data.length !== 0) setExpanded(false);
        setTableData(data);
      }
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something went wrong! Try again.', 'error');
    }
    hideLoading();
  }

  // pagination
  const { totalRows, currentPage } = useMemo(() => {
    const totalRows = getDataForView.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const currentPage = Math.max(0, Math.min(page, totalPages - 1));
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, totalRows - page * rowsPerPage);

    return { totalRows, currentPage };
  }, [getDataForView, page, rowsPerPage]);

  const [isDialogOpen, setDialogOpenState] = useState(false); // Unique state for dialog visibility
  const [currentOrderDetails, setCurrentOrderDetails] = useState(null); // Unique state for selected order details

  const handleReviewButtonClick = (order) => {
    setCurrentOrderDetails(order); // Set the selected order details
    setDialogOpenState(true); // Open the dialog
  };

  const closeDialog = () => {
    setDialogOpenState(false); // Close the dialog
    setCurrentOrderDetails(null); // Clear selected order details
  };

  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2 }} elevation={3}>
        {/* table header */}
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              // borderRadius: 50,
              background: '#8EACCD',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              Manage Pick Up
            </Typography>
          </Typography>
        </Grid>

        <Grid container spacing={2} p={1} my={1} rowSpacing={3} columnSpacing={1}>
          <Grid item md={4} xs={12}>
            <Autocomplete
              options={countryFilterData}
              getOptionLabel={(country) => country}
              renderOption={(props, country) => (
                <li {...props} key={country}>
                  {country}
                </li>
              )}
              isOptionEqualToValue={(country) =>
                country === filterInputs.country
              }
              value={filterInputs.country || null}
              name="country"
              onChange={(event, value) => {
                setFilterInputs({ ...filterInputs, country: value });
              }}
              size="small"
              renderInput={(params) => <TextField {...params} label="Country" />}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Autocomplete
              multiple
              options={pinCodeFilterData}
              getOptionLabel={(salesPerson) => salesPerson.salesPersonName}
              renderOption={(props, salesPerson) => (
                <li {...props} key={salesPerson.salesPersonId}>
                  {salesPerson.salesPersonName}
                </li>
              )}
              isOptionEqualToValue={(salesPerson) =>
                salesPerson.salesPersonId === filterInputs.salesExecutive.salesPersonId
              }
              value={filterInputs.pinCode || null}
              name="pincode"
              onChange={(event, value) => {
                setFilterInputs({ ...filterInputs, pinCode: value });
              }}
              size="small"
              renderInput={(params) => <TextField {...params} label="Pin Codes" />}
            />
          </Grid>
          <Grid item xs={2} sx={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
            {/* View Button */}
            <Button variant="contained" color="primary" onClick={getAllData} fullWidth sx={{ boxShadow: 0 }}>
              View
            </Button>
          </Grid>
          <Grid item md={2} xs={12}>
            {/* To Date */}
            <TextField
              fullWidth
              label="To Date"
              type="date"
              inputProps={{ max: '9999-12-31' }}
              name="toDate"
              value={filterInputs.toDate}
              onChange={handleFilterInputs}
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              size="small"
            />
          </Grid>
        </Grid>

        <Collapse in={tableData.length <= 0}>
          <>
            <TableContainer component={Paper} elevation={2} sx={{ bgcolor: 'inherit', maxHeight: 600 }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center">S.No</StyledTableCell>
                    <StyledTableCell align="left">Order No</StyledTableCell>
                    <StyledTableCell align="left">Ledger Details</StyledTableCell>
                    <StyledTableCell align="left">Order Date</StyledTableCell>
                    <StyledTableCell align="center">Contact No</StyledTableCell>
                    <StyledTableCell align="center">Sender Name</StyledTableCell>
                    <StyledTableCell align="center">Sender No</StyledTableCell>
                    <StyledTableCell align="center">City</StyledTableCell>
                    <StyledTableCell align="center">State</StyledTableCell>
                    <StyledTableCell align="center">Pincode</StyledTableCell>
                    <StyledTableCell align="center">Mail Id </StyledTableCell>
                    <StyledTableCell align="center">Sales Executive</StyledTableCell>
                    <StyledTableCell align="center" sx={{ position: 'sticky', right: 0, zIndex: 2 }}>
                      Actions
                    </StyledTableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {(rowsPerPage > 0
                    ? tableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    : tableData
                  ).map((data, i) => (
                    <>
                      <TableRow key={`${data.customerId}${data.orderNo}${data.orderId}`} hover>
                        <TableCell align="center">{page * rowsPerPage + (i + 1)}</TableCell>
                        <TableCell align="center">{data.orderNo || '-'}</TableCell>
                        <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
                          <Stack spacing={1} py={1}>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <PortraitIcon fontSize="x-small" color="primary" />
                              <Typography variant="body2" pr={1}>
                                {data.customerName || '-'}
                              </Typography>{' '}
                            </Stack>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <Phone fontSize="x-small" color="success" />
                              <Typography variant="body2" mr={2} pr={1}>
                                {data.phone || '-'}
                              </Typography>{' '}
                              | <Email fontSize="x-small" color="error" />
                              <Typography variant="body2" pr={1} sx={{ textTransform: 'lowercase' }}>
                                {data.emailId || '-'}
                              </Typography>
                            </Stack>{' '}
                          </Stack>
                        </TableCell>

                        <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
                          {moment(data.orderDate).format('DD/MM/YYYY') || '-'}
                        </TableCell>

                        <TableCell align="center">{data.shipmentType || '-'}</TableCell>
                        <TableCell align="center">{data.salesExecutives || '-'}</TableCell>
                        <TableCell align="center">{data.gross_weight || '-'}</TableCell>
                        <TableCell align="center">
                          {data.approvalStatus === 'Y' ? (
                            <Chip label="Approved" size="small" color="success" />
                          ) : (
                            <Chip label="Pending" size="small" color="warning" />
                          )}
                        </TableCell>

                        <TableCell align="center">
                          {data.orderStatus === 'N' ? (
                            <Chip label="Approved" size="small" color="success" />
                          ) : (
                            <Chip label="Canceled" size="small" color="error" />
                          )}
                        </TableCell>
                        <TableCell align="center">
                          {data.billStatus === 'Y' ? (
                            <Chip label="Approved" size="small" color="success" />
                          ) : (
                            <Chip label="Pending" size="small" color="warning" />
                          )}
                        </TableCell>
                        <TableCell align="center">
                          {data.receiptStatus === 'Y' ? (
                            <Chip label="Approved" size="small" color="success" />
                          ) : (
                            <Chip label="Pending" size="small" color="warning" />
                          )}
                        </TableCell>
                        <TableCell align="center">{data.paidAmount || '-'}</TableCell>
                        <TableCell align="center" sx={{ position: 'sticky', right: 0, bgcolor: '#F9FAFB', zIndex: 1 }}>
                          <Stack direction="column" spacing={1} justifyContent="center" alignItems="center">
                            <IconButton aria-label="" onClick={() => handleReviewButtonClick(data)}>
                              <PreviewIcon fontSize="small" color="primary" />
                            </IconButton>
                            {/* <Button
                                variant="outlined"
                                color="primary"
                                sx={{ boxShadow: 1 }}
                                onClick={null}
                                size="small"
                                fullWidth
                                startIcon={<PreviewIcon fontSize="small" />}
                              >
                                Review
                              </Button> */}
                          </Stack>
                        </TableCell>
                      </TableRow>
                    </>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={totalRows}
              rowsPerPage={rowsPerPage}
              page={currentPage}
              onPageChange={(event, newPage) => setPage(newPage)}
              onRowsPerPageChange={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
              }}
              mt={2}
            />
          </>
        </Collapse>

        {/* Dialog to display review content */}
        <Dialog fullScreen open={isDialogOpen} onClose={closeDialog}>
          <DialogTitle>
            Order Review
            <IconButton
              edge="end"
              color="inherit"
              onClick={closeDialog}
              aria-label="close"
              sx={{ position: 'absolute', right: 16, top: 16 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            {currentOrderDetails && <CourierOrderCreation orderDetails={currentOrderDetails} />}
          </DialogContent>
        </Dialog>
      </Container>
    </>
  );
};

export default ManagePickUp;
